import { IconClock } from '@tabler/icons-react'

/**
 * Prominent empty-state shown on the "Widgets" tab of the workspace app/widget
 * pickers. Workspace widgets are not available yet, so the (placeholder) widget
 * catalogue is intentionally hidden and this "coming soon" state is shown in its
 * place. The dummy widget data still exists in code so it can be re-enabled once
 * the real widgets ship.
 */
const WidgetsComingSoon = () => (
  <div
    data-testid="workspace-widgets-coming-soon"
    className="flex h-full min-h-[240px] w-full flex-col items-center justify-center gap-3 px-6 text-center">
    <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-primary-10)] text-[var(--color-primary)]">
      <IconClock size={32} stroke={1.5} />
    </span>
    <h5 className="m-0 text-lg font-semibold theme-text-heading">Widgets are coming soon</h5>
    <p className="m-0 max-w-[360px] text-sm theme-text-subheading">
      We&rsquo;re building a library of workspace widgets. You&rsquo;ll be able to browse and add
      them here soon.
    </p>
  </div>
)

export default WidgetsComingSoon
